import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Socials = () => {
    const height = 50;
    const width = 50;
    const color = "default"; // Replace with your light mode color
    const darkModeColor = "white"; // Replace with your dark mode color
    const isDarkMode = false; // Toggle based on your app's state

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const getIconUrl = (iconSlug) =>
        `https://cdn.simpleicons.org/${iconSlug}/${
            isDarkMode ? darkModeColor : color
        }`;

    const mediaLinks = [
        {
            category: "Social Media",
            data: [
                {
                    name: "Instagram",
                    slug: "instagram",
                    link: "https://www.instagram.com/pratham_reet",
                },
                { name: "X", slug: "x", link: "https://x.com/prathamreet" },
                // { name: "YouTube", slug: "youtube", link: "https://www.youtube.com/yourprofile" },
                {
                    name: "Medium",
                    slug: "medium",
                    link: "https://medium.com/@prathamreet",
                },
                {
                    name: "Monkeytype",
                    slug: "monkeytype",
                    link: "https://monkeytype.com/profile/prathamreet",
                },
            ],
        },
        {
            category: "Professional Media",
            data: [
                {
                    name: "LinkedIn",
                    slug: "linkedin",
                    link: "https://www.linkedin.com/in/pratham-reet-428aa5328/",
                },
                {
                    name: "GitHub",
                    slug: "github",
                    link: "https://github.com/prathamreet",
                },
                {
                    name: "Stack Overflow",
                    slug: "stackoverflow",
                    link: "https://stackoverflow.com/users/27630288/pratham-reet",
                },
                {
                    name: "LeetCode",
                    slug: "leetcode",
                    link: "https://leetcode.com/u/prathamreet/",
                },
            ],
        },
    ];

    return (
        <div className="container mx-auto p-8 rounded-lg shadow ubuntu-regular">
            <h2 className="text-3xl font-bold text-left">
                Connections
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                {mediaLinks.map((section, index) => (
                    <div key={index}>
                        <h3
                            className="text-lg font-semibold text-center text-yellow-500 m-8"
                            data-aos="fade-in"
                        >
                            {section.category}
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 gap-8 my-6">
                            {section.data.map(({ name, slug, link }) => (
                                <div
                                    key={name}
                                    className="flex flex-col items-center"
                                    data-aos="zoom-in-up"
                                >
                                    <a
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <div className="transition-transform hover:scale-110 flex flex-col items-center justify-center">
                                            <img
                                                height={height}
                                                width={width}
                                                src={getIconUrl(slug)}
                                                alt={name}
                                            />
                                            <span className="mt-2 text-sm text-center">
                                                {name}
                                            </span>
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Socials;
